// src/internal/components/help-center-panel/hooks/useEvents.ts
import { useMemo } from "react";
import { useAuthContext } from "@clara/auth";
import { useLocaleContext } from "@clara/locale";
var useEvents = () => {
  const { user } = useAuthContext();
  const { lang } = useLocaleContext();
  const eventData = useMemo(() => {
    return {
      userUUID: user == null ? void 0 : user.uuid,
      companyUUID: user == null ? void 0 : user.companyUuid,
      role: user == null ? void 0 : user.role,
      translation_selected: lang
    };
  }, [user, lang]);
  return { eventData };
};

export {
  useEvents
};
